import { Button, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import TableDmthuocvattuList from "./TableDmthuocvattuList";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllDmdonvitinh,
  getAllDmLoaiDv,
  searchDmThuocVatTu,
} from "store/slices/sale/danhmucSlice";
import DocumentViewer from "constants/DocumentViewer";
import { v4 as uuidv4 } from "uuid";
import { PrinterOutlined } from "@ant-design/icons";
import MeditechTablePage, { FilterComponent } from "components/table-layout";

const initSearch = {
  action: "initial",
  isRequired: true,
  timKiem: "",
  maLoaiDichVu: [],
};

export const initDmthuocvattu = {
  action: "initial",
  isRequired: true,
  timKiem: "",
  maLoaiDichVu: null,
};
const DmthuocvattuList = () => {
  const dispatch = useDispatch();
  const { permitList } = useSelector((state) => state.auth);
  const { searchDmThuocVatTuList, allDmLoaiDvList, loading } = useSelector(
    (state) => state.danhMucSale
  );
  const [isprinter, setIsPrinter] = useState(false);
  const [printData, setPrintData] = useState({});
  const [sMaLoaiDichVu, setSMaLoaiDichVu] = useState("");
  const [sTimKiem, setSTimKiem] = useState("");
  useEffect(() => {
    dispatch(getAllDmdonvitinh({}));
    dispatch(getAllDmLoaiDv({}));
    reloadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const reloadData = () => {
    searchFormRef.current = { ...searchFormRef.current };
    dispatch(searchDmThuocVatTu(searchFormRef.current));
  };

  const searchFormRef = useRef({ ...initSearch });
  const [searchFormData, setSearchFormData] = useState(searchFormRef.current);
  const searchHandle = (dataSearch) => {
    searchFormRef.current = { ...searchFormRef.current, ...dataSearch };
    setSearchFormData({ ...searchFormRef.current });
    reloadData();
  };
  const onRenderSearchView = () => {
    return (
      <FilterComponent
        datasource={searchFormData}
        onSearchImmediate={searchHandle}
        // renderFilterMoreView={renderFilterMoreView}
        renderInputSearch
        renderDatePicker={false}
      >
        <Select
          key="maLoaiDichVu"
          data-field="maLoaiDichVu"
          style={{ width: "100%", minWidth: 200 }}
          placeholder="Loại dịch vụ"
          options={allDmLoaiDvList.map((m) => ({
            value: m.maloaidichvu,
            label: m.tenloaidichvu,
          }))}
          allowClear
          mode="multiple"
        />
        <Button
          style={{
            float: "right",
            width: "80px",
            marginLeft: "15px",
          }}
          onClick={() => {
            setIsPrinter(true);
            setPrintData({
              idphieu: uuidv4(),
              sophieu: "Danh mục hàng hóa",
            });
            let nhomdulieu = "";
            if (searchFormRef.current.maLoaiDichVu.length > 0)
              searchFormRef.current.maLoaiDichVu.forEach((item) => {
                nhomdulieu += (nhomdulieu !== "" ? ";" : "") + item;
              });
            setSMaLoaiDichVu(nhomdulieu);
            setSTimKiem(searchFormRef.current.timKiem + "");
          }}
          type="primary"
          icon={<PrinterOutlined />}
          block
        >
          In
        </Button>
      </FilterComponent>
    );
  };

  // const onDeleteHandler = (id) => {
  //   // dispatch(
  //   //   DeletePhuongAnKinhDoanh({
  //   //     id: id,
  //   //     onSuccess: ({ data }) => {
  //   //       if (data.isOk) {
  //   //         reloadData();
  //   //         notification.info({
  //   //           message: "Xóa hợp đồng khám sức khỏe",
  //   //           description: "Xóa phiếu thành công",
  //   //         });
  //   //       } else {
  //   //         notification.error({
  //   //           message: "Xóa hợp đồng khám sức khỏe",
  //   //           description: data.description,
  //   //         });
  //   //       }
  //   //     },
  //   //   })
  //   // );
  // };

  // const onOpenDetailHandler = (id) => {
  //   // setPhuongAnId(id);
  //   // setVisibleModal(true);
  // };

  const getRightButton = (isLocked) => {
    const arr = [];
    if (isLocked) {
      // arr.push({
      //   keyName: SystemButtonSource.addBtn,
      //   title: "Thêm",
      //   showMore: false,
      //   // disable: !allowAddNew,
      // });
    }
    return arr;
  };

  const onRightTopBtnHandler = (key) => {
    // switch (key) {
    //   case SystemButtonSource.addBtn:
    //     setVisibleModal((prev) => !prev);
    //     break;
    //   default:
    //     break;
    // }
  };

  return (
    <>
      <MeditechTablePage
        tableTitle="DANH MỤC THUỐC VẬT TƯ"
        btnHeaderRightSource={getRightButton(true)}
        btnHeaderRightSourceHandle={onRightTopBtnHandler}
        onRenderSearchView={onRenderSearchView}
      >
        <TableDmthuocvattuList
          loading={loading}
          allDmthuocvattuList={searchDmThuocVatTuList}
          reloadData={() => reloadData()}
          permitList={permitList}
        />
        <DocumentViewer
          openModel={isprinter}
          setIsPrinter={setIsPrinter}
          soPhieu={printData.sophieu}
          idPhieu={printData.idphieu}
          setPrintData={setPrintData}
          param={{
            timkiem: sTimKiem,
            maloaidichvu: sMaLoaiDichVu,
          }}
          tenMauIn={"DanhMucSale.rptDanhMucHangHoa"}
          loaiPhieu={"DanhMucSale"}
          tieuDe={"Danh mục hàng hóa"}
        />
      </MeditechTablePage>
    </>
  );
};

export default DmthuocvattuList;
